import { FranchiseAppGlobal, LookupCategories } from '../../app/franchise-app-global'
import { HttpClient } from '@angular/common/http'

import { AppConfigService } from '../shared/providers/config.service';
import { Injectable } from '@angular/core'
import { LookupModel } from '../franchise-creation/models/models'
import { Observable } from 'rxjs';

@Injectable()
export class LookupService {
    private env;
    constructor(
        public http: HttpClient,
        private config: AppConfigService
    ) {
        this.env = this.config.getConfig();
    }


    GetRegions(): Observable<any[]> {
        let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsByCategoryUrl + LookupCategories.Regions;
        return this.http.get<any[]>(url)
    }
    GetAdminRegions(): Observable<any[]> {
        let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsAdminByCategoryUrl + LookupCategories.Regions;
        return this.http.get<any[]>(url)
    }
    GetCountries(): Observable<any[]> {
        let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsByCountryUrl;
        return this.http.get<any[]>(url)
    }

    GetCancelFranchiseReasons(): Observable<any[]> {
        let url = this.env.baseUrl + FranchiseAppGlobal.getAllCancelReason;
        return this.http.get<any[]>(url)
    }

    GetDistrictsByCities(cities: number[]): Observable<any[]> {
        const cityIds = cities.join(',');
        let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsByDistrictUrl + cityIds;
        return this.http.get<any[]>(url)
    }

    GetCitiesByRegionId(regionId: any): Observable<any[]> {
        let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsByParentUrl + regionId
        return this.http.get<any[]>(url)
    }

    GetCitiesByRegionsIds(regionIds: any, cities: LookupModel[]): Observable<any[]> {
        let requestModel = { parentIds: regionIds, childs: cities }
        let url = this.env.baseUrl + FranchiseAppGlobal.getLimitidLookupsByParentsUrl
        return this.http.post<any[]>(url, requestModel)
    }
    
    GetAdminCitiesByRegionsIds(regionIds: any): Observable<any[]> {
        let requestModel = { parentIds: regionIds }
        let url = this.env.baseUrl + FranchiseAppGlobal.getAdminLimitidLookupsByParentsUrl
        return this.http.post<any[]>(url, requestModel)
    }
    getDisclosureAttachmentType() {
        return 1;
        // let url = this.env.baseUrl + FranchiseAppGlobal.getAllLookupsByCategoryUrl + LookupEnum.Regions
        // return this.http.get(url)
    }
}
